import moment from "moment";
import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../../theme/colors";

interface LetterCardProps {
  name: string;
  lastname: string;
  date: number;
  actions?: ReactNode;
}

const LetterCard = ({ name, lastname, date, actions }: LetterCardProps) => {
  return (
    <Container>
      <InfoWrapper>
        <Title>{`${lastname}, ${name}`}</Title>
        <Time>{moment(date).fromNow()}</Time>
      </InfoWrapper>
      {actions !== undefined && <ActionsWrapper>{actions}</ActionsWrapper>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.White};
  padding: ${8 * 2}px;
  border-radius: 15px;
  border-color: ${Colors.Border};
  border-width: 1px;
  border-style: solid;
`;

const InfoWrapper = styled.div``;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: ${8}px;
`;

const Time = styled.div``;

const ActionsWrapper = styled.div`
  justify-self: flex-end;
  margin-left: ${8 * 2}px;
`;

export default LetterCard;
